import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckList from '@/components/CheckList.vue';
import CharacterSheetModifier from './CharacterSheetModifier.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import { isEmpty, filter, startCase } from 'lodash';
let CharacterSheetSuperiority = class CharacterSheetSuperiority extends Vue {
    constructor() {
        super(...arguments);
        this.isEmpty = isEmpty;
        this.startCase = startCase;
    }
    get types() {
        const hasPhysicalManeuvers = this.superiority.maneuvers.some(({ type }) => type === 'Physical');
        const hasMentalManeuvers = this.superiority.maneuvers.some(({ type }) => type === 'Mental');
        const hasGeneralManeuvers = this.superiority.maneuvers.some(({ type }) => type === 'General') && ((hasPhysicalManeuvers && hasMentalManeuvers) ||
            (!hasPhysicalManeuvers && !hasMentalManeuvers) ||
            (hasPhysicalManeuvers && !hasMentalManeuvers && this.superiority.generalSaveDC > this.superiority.physicalSaveDC) ||
            (hasMentalManeuvers && !hasPhysicalManeuvers && this.superiority.generalSaveDC > this.superiority.mentalSaveDC));
        return filter([hasPhysicalManeuvers && 'physical', hasGeneralManeuvers && 'general', hasMentalManeuvers && 'mental']);
    }
    handleUpdateSuperiorityDice(superiorityDiceUsed) {
        this.$emit('updateCharacter', { currentStats: { superiorityDiceUsed } });
    }
};
__decorate([
    Prop(Object)
], CharacterSheetSuperiority.prototype, "superiority", void 0);
__decorate([
    Prop(Object)
], CharacterSheetSuperiority.prototype, "tweaks", void 0);
CharacterSheetSuperiority = __decorate([
    Component({
        components: {
            CheckList,
            CharacterSheetModifier,
            CharacterSheetTweaker,
            CharacterSheetExpansionFeatures
        }
    })
], CharacterSheetSuperiority);
export default CharacterSheetSuperiority;
